import styled from "styled-components";
import { View } from "@components";

export const DescriptionLine = styled(View)`
  justify-content: space-between;
  flex-direction: row;
`;
